// src/api/user-management-api.ts
import { userManagerUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { ZitadelUser } from "@src/types/user-management";

export const getUsers = async (namespace: string, signal: AbortSignal) => {
  const url = userManagerUrlEnvVar();

  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<ZitadelUser[]>(
      `${url}/api/v1/ns/${namespace}/users/human`,
      {
        headers: headers,
        signal: signal,
      },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      if (err.code === "ERR_CANCELED") return;
      console.error("Axios error:", err);

      throw err;
    } else {
      throw new Error("An unexpected error occurred while fetching users.");
    }
  }
};
